import { useContext, Fragment } from 'react';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TotalPeopleEnrolledCard from '../../../components/dashboard/enrollment/TotalPeopleEnrolledCard';
import EnabledDisabledCard from '../../../components/dashboard/enrollment/EnabledDisabledCard';
import EnrolledByGroupCard from '../../../components/dashboard/enrollment/EnrolledByGroup';
import QualityScoreCard from '../../../components/dashboard/enrollment/QualityScoreCard';
import QualityScoreBreakdownCard from '../../../components/dashboard/enrollment/QualityScoreBreakdownCard';
import PeopleEnrolledChartCard from '../../../components/dashboard/enrollment/PeopleEnrolledChartCard';
import { EnrollmentsContext } from '../../../context/enrollment-context';

export default function EnrollmentAnalytics() {
    const { data } = useContext(EnrollmentsContext);

    return (
        <Fragment>
            <PeopleEnrolledChartCard />
            <QualityScoreCard data={data?.enrollmentsQualityScore} />
            
            <Grid container={true} item={true} xs={8} spacing={3} sx={{ padding: '0px 0px 0px 0px' }}>
                <EnrolledByGroupCard data={data?.enrollmentsEnrolledByGroup} />
                <Grid item={true} xs={6}>
                    <Stack spacing={3} sx={{ justifyContent: 'space-evenly'}}>
                        <TotalPeopleEnrolledCard data={data?.enrollmentsTotalCount} />
                        <EnabledDisabledCard data={data?.enrollmentsEnabledVsDisabled} />
                    </Stack>
                </Grid>

                <QualityScoreBreakdownCard data={data?.enrollmentsQualityScoreBreakdown} />
            </Grid>
           
        </Fragment>
    )
}